export const isProfileItemDisabled = (item) => {
  if (!item) return false;
  const status = item.status;
  return status === 0 || status === "0" || status === false;
};

export const isProfileItemEnabled = (item) => {
  if (!item) return false;
  const status = item.status;
  return status === 1 || status === "1" || status === true;
};

export const getVisibleProfileItems = (items, isViewingOwn) => {
  if (!items?.length) return [];
  if (isViewingOwn) return items;
  return items.filter((item) => !isProfileItemDisabled(item));
};

/** Public resume / PDF views — always hide disabled entries. */
export const getVisibleResumeItems = (items) => {
  if (!items?.length) return [];
  return items.filter((item) => !isProfileItemDisabled(item));
};
